import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
  isLoading: false,
  openModalUserReservationDetail: false,
};

const slice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // OPEN MODAL

    onOpenModalUserReservationdetailPopup(state) {
      state.openModalUserReservationDetail = true;
    },

    // CLOSE MODAL

    onCloseModalForUserReservationDetail(state) {
      state.openModalUserReservationDetail = false;
    },

    onCloseModal(state) {
      state.openModalUserReservationDetail = false;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { onCloseModal, onOpenModalUserReservationdetailPopup,  onCloseModalForUserReservationDetail } = slice.actions;
